import { computed, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'
import { consultRemind, selectByDoctorName } from '@/api/chat'
import moment from 'moment'
const rules = {
  date: [
    {
      required: true,
      message: '日期必选项',
      trigger: 'blur'
    }
  ],
  time: [
    {
      required: true,
      message: '时间必选项',
      trigger: 'blur'
    }
  ]
}
export default function main() {
  const store = useStore()
  const patientInfo = computed(() => store.state.workOrder.workOrderGroupInfo.patientInfo)
  const doctorInfo = computed(() => store.state.workOrder.workOrderGroupInfo.doctorInfo)
  // 显示隐藏对话框
  const notifyModal = ref(false)
  const DT = reactive({
    date: '',
    time: ''
  })
  const consultDOM = ref(null)
  function handleOk() {
    consultDOM.value.validate().then(() => {
      const _doctorId = ~~doctorInfo.value.userId,
        _patientId = ~~patientInfo.value.ucUserId,
        _remindTime = `${DT.date} ${DT.time}`
      consultRemind(_doctorId, _patientId, _remindTime).then(() => {
        notifyModal.value = false
        message.success('设置保存成功')
      })
    })
  }
  function onCancel() {
    consultDOM.value.clearValidate()
    notifyModal.value = false
  }
  const doctor = reactive({
    // 医生名称
    name: '',
    // 医生id
    id: '',
    // 医生下拉选
    options: []
  })
  function onSelectDoctor(e) {
    doctor.id = e.id
    doctor.name = doctor.options.find(v => v.id === e).name
  }
  function onSearchDoctor(e) {
    console.log(e)
    doctor.options.splice(0)
    selectByDoctorName(e).then(res => {
      doctor.options = res
    })
  }
  function onShowNotifyModal() {
    notifyModal.value = true
    const date = new Date()
    DT.date = moment(date).format('YYYY-MM-DD')
    // 当前时间加一个小时
    DT.time = moment(date).add(1, 'hours').format('HH:mm:00')
  }
  return {
    patientInfo,
    doctorInfo,
    notifyModal,
    rules,
    DT,
    doctor,
    consultDOM,
    onSelectDoctor,
    onSearchDoctor,
    onCancel,
    handleOk,
    onShowNotifyModal
  }
}
